import { DestroyRef, Directive, inject, TemplateRef } from '@angular/core';
import { DetailDrawerFrame } from './detail-drawer-frame.service';

/**
 * Marks the item's controls — star, menu, download — for the drawer to show beside its trail:
 *
 * ```html
 * <ng-template lpDetailDrawerActions><lp-favorit-star … /></ng-template>
 * ```
 *
 * The template keeps the item's own bindings and styles; only where it renders moves.
 */
@Directive({ selector: 'ng-template[lpDetailDrawerActions]' })
export class DetailDrawerActionsDirective {
  private readonly frame = inject(DetailDrawerFrame);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);

  constructor() {
    this.frame.showActions(this.templateRef);
    inject(DestroyRef).onDestroy(() => this.frame.clearActions(this.templateRef));
  }
}
